import { render, staticRenderFns } from "./MaintainPage.vue?vue&type=template&id=b9b8323a&scoped=true"
import script from "./MaintainPage.vue?vue&type=script&lang=js"
export * from "./MaintainPage.vue?vue&type=script&lang=js"
import style0 from "./MaintainPage.vue?vue&type=style&index=0&id=b9b8323a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b8323a",
  null
  
)

export default component.exports